import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {Vehicle, VehicleDocument} from "domain-models"
import _ from 'lodash'
import React from "react"
import {GlobalState} from "../../../../state"
import {connect} from "react-redux"
import Trans from '../../../../components/Trans'

type VehicleDocumentsProps = {
  documents: Array<VehicleDocument>
  dossierId: number | null
}

type VehicleDocumentsState = {
  isPrinting: boolean
}

class Documents extends React.Component<VehicleDocumentsProps, VehicleDocumentsState> {
  constructor(props: VehicleDocumentsProps) {
    super(props)

    this.state = {
      isPrinting: false
    }
  }

  printDossier = async () => {
    this.setState({isPrinting: true})
    const response = await window.axios.post<{ Url: string }>('/printDossier', {
      context: {DossierId: this.props.dossierId},
      report: 'car-inspector',
      variant: 'protocol',
      settings: {},
    })

    if (response.data.Url) {
      window.open(response.data.Url, '_BLANK')
    }

    this.setState({isPrinting: false})
  }

  render() {
    return (this.props.documents && this.props.documents.length) || this.props.dossierId ? (
      <div className="w-full flex flex-row flex-wrap mt-6 md:mt-0">
        <div className='font-semibold text-gray-700 w-full'>
          <span><Trans>Dokumente</Trans></span>
        </div>

        <div className="w-full flex flex-col">
          <div className="border-t border-gray-300 my-1"/>

          {_.map(this.props.documents, document => (
            <div key={document.Id}>
              <button className='w-full rounded bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 py-2 font-semibold whitespace-no-wrap shadow text-xs truncate my-1' onClick={() => {
                window.open(document.Url, '_BLANK')
              }}>
                <Icon icon="cloud-download-alt"/>
                <span> {document.Title}</span>
              </button>
            </div>
          ))}
        </div>
      </div>
    ) : null
  }
}

export default connect((state: GlobalState) => {
  const vehicle = state.auctions.auction ? _.first(state.auctions.auction.subjects)?.vehicle : null
  return {
    dossierId: vehicle && vehicle.ci_vehicle ? vehicle.ci_vehicle.DossierId : null,
  }
})(Documents)
